import { v4 as uuidv4 } from "uuid";

export interface PushConnectorFormField {
  label: string;
  value: string;
}

export const initialPushConnectorForm: PushConnectorFormField[] = [
  { label: "name", value: "" },
  { label: "description", value: "" },
  { label: "prompt", value: "" },
];

export type PushConnectorData = { [label: string]: string };

export interface PushConnector {
  id?: string;
  name: string;
  description: string;
  data: PushConnectorData;
}

export interface PushConnectorObject {
  type: "omega/query-omega/push-connector/PushConnector";
  "push-con-id": string;
  "push-con-spec": PushConnectorData;
  "app-id": string;
}

export const pushConFormDataToObject = (config: {
  formData: PushConnectorData;
  appId: string;
}): PushConnectorObject => {
  const { formData, appId } = config;
  return {
    type: "omega/query-omega/push-connector/PushConnector",
    "push-con-id": uuidv4(),
    "push-con-spec": formData,
    "app-id": appId,
  };
};

export interface PushConnectorCreated extends PushConnector {
  id: string;
}

export type PushConnectorMap = { [id: string]: PushConnectorCreated };
